var site = site || {};

site.device = {};
site.window = {};
site.owl = {};
site.nav = {};
site.search = {};
site.sidebar = {};
site.hero = {};
site.dropdownMenu = {};

site.device.isTouch = function() {
	try {
		document.createEvent("TouchEvent");
		return true;
	} catch (e) {
		return false;
	}
};

site.window.scrollPosition = 0;

// Shorthand to init owlcarousel
site.owl.init = function(id, options) {
	var $owl = $(id);
	if ($owl.length > 0) {
		$owl.owlCarousel(options);
	}
};

site.search.init = function() {
	$navbar = $('#mainmenu');
	$searchDrop = $('#searchDrop');
	$navbar.find('.gler').click(function() {
		$this = $(this);
		if($this.hasClass('open')) {
			$this.toggleClass('open');
			$searchDrop.css('maxHeight',0);

			setTimeout( function() {
				$searchDrop.removeClass('open').removeAttr('style');
			}, 600);
		}
		else {
			$this.toggleClass('open');
			$searchDrop.toggleClass('open').find('#q').focus();
		}
	});
};

site.dropdownMenu.init = function() {

	var $body = $('body');
	$mmLevel2 = $('ul.mmLevel2', '.quicknav');
	$mmLevel2.removeClass('hide');
	if ($body.width()+15 >= 992) {
		$('.quicknav .level1.children > ul').each(function () {
			var $this = $(this);
			$this.css('max-height', $this[0].scrollHeight+80);
		});
	};
	$('.level1.children a', '.quicknav').on('click', function (e) {

		var $this = $(this);
		if ($body.width()+15 >= 992) {
			if ($(this).parent().hasClass('level1')) {
				e.preventDefault();
				e.stopPropagation();
				$this.parent().siblings().removeClass('open');
				$body.removeClass('search-open');

				if (!$this.parent().hasClass('open')) {
					$this.parent().addClass('open');
					$body.toggleClass('dropdown-open');
					$('body.dropdown-open').on('click', function (e) {
						$body.removeClass('dropdown-open');
						$('.level1.open','.quicknav').removeClass('open');
					});
				}
				else {
					$body.removeClass('dropdown-open');
					$('.level1.open','.quicknav').removeClass('open');
				}
			}
		}
	});
};

// Init navigation scripts
site.nav.init = function() {
	// Add expand link to mobile menu
	$('.children', '#mainmenu').prepend('<a class="expand" href="#"><i class="fa fa-angle-right"></i></a>');
	$('.selectedLevel1','#mainmenu').addClass('down');
	$('.selectedLevel2','#mainmenu').addClass('down');
	$('.selectedLevel3','#mainmenu').addClass('down');
	site.nav.bind();
};

// Bind events
site.nav.bind = function() {
	// Mobile menu toggle
	$('#mainmenuToggle').click(function(e) {
		var menuOpen = $('body').hasClass('mainmenu-open');
		if (!menuOpen) {
			site.window.scrollPosition = $(window).scrollTop();
		}
		site.nav.mobileToggle(e, menuOpen, site.window.scrollPosition);
		e.preventDefault();
	});

	// Expand in mobile menu
	$('.expand', '#mainmenu').bind('click', function(e) {
		e.preventDefault();
		var $this = $(this);
		$this.closest('li').toggleClass('down');
	});
	site.nav.appendStuff();
};

// Toggle mobile menu
site.nav.mobileToggle = function(e, menuOpen, scrollPosition) {
	$('body').toggleClass('mainmenu-open');
	$(this).toggleClass('open');
	if (!menuOpen) {
		$(window).scrollTop(0);
		$('i', '#mainmenuToggle').removeClass('fa-bars').addClass('fa-close');
	}
	else {
		$(window).scrollTop(scrollPosition);
		$('i', '#mainmenuToggle').removeClass('fa-close').addClass('fa-bars');
	}
};

// Append language to mobilemenu
site.nav.appendLanguage = function() {
	var $divisions = $('.menu', '#divisions');
	var $menu = $('ul.mmLevel1', '#mMenu');

	var $html = $('<li class="ele-language si level1"></li>');
	$divisions.find('li').each(function() {
		var $li = $(this).clone();
		$html.append($li.find('a'));
	});

	$menu.append($html);
};

// Append language, qn and search
site.nav.appendStuff = function() {
	var $qn = $('qnMenu');
	var $divisions = $('.menu', '#divisions');
	var $header = $('.container','#header');
	var $menu = $('ul.mmLevel1', '#mainmenu');

	// Append division to header
	var $html = $('<div class="lang" />');
	$html.append($divisions.clone());
	$header.append($html);

	//Search for vikudagur
	if($('body').hasClass('is')) {
		var $search = $('<div class="mSearch" />');
		$search.append($('form','#searchDrop').clone());
		$('#mainmenu').prepend($search);
	}

	//Append logo
	var $logo = $header.find('.logo').clone();
	$('#mainmenu').prepend($logo);



	//Quicknav
	/*var $html2 = $('<li class="ele-qn si level1"></li>');
	$html2.append($('#pageContainer .quicknav').clone());
	$menu.append($html2);*/
};

// Local
site.local = {};

// Market related js
site.local.market = {
	init : function () {
		$('.market-login-toggle').click(function () {
			$('.market-login-form').toggle();
			$('.mlogin').toggleClass('selected');
			return false;
		});
		$('.market-nav-toggle').click(function () {
			$('.market-nav-menu').toggle();
			return false;
		});
	}
};

// Drop down
// Run all the inits \o/
$(function() {
	site.nav.init();
	site.owl.init('#reviews > ul', {
		loop:true,
		nav:true,
		navText:["",""],
		items: 1
	});
	site.local.market.init();
	site.search.init();
	site.dropdownMenu.init();

	if($('body').hasClass('frontpage') && $('body').hasClass('is')) {
		$m = $("#main");
		$m.find('.box_pdf .boxTitle h2').wrapInner('<a href="/is/flettu" title="" />');
		$m.find('.box_weather .boxTitle h2').wrapInner('<a href="http://www.vedur.is" target="_blank" title="" />');
		$m.find('.box_galleryimage .boxTitle h2').wrapInner('<a href="/is/myndir" title="" />');
		$m.find('.box_greinar .boxTitle h2').wrapInner('<a href="/is/frettir/adsendar-greinar" title="" />');
		$m.find('.box_matur .boxTitle h2').wrapInner('<a href="/is/matarkrokurinn" title="" />');


	}
	// Responsive tables
	if(!$('body').is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
		$('.table1','#main').addClass('table table-striped');

		$('#moya_form_smaauglysingar-i-dagskranni textarea').attr('maxlength','160');
	}

	// Touch login
	$('.login').bind('click', function(e) {
		e.preventDefault();
		window.location = '/moya';
	});
});
